module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Overblik",
      "identifier": "index"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Overblik</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvad skal der fokus på i dag?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "economy-overview-boxes"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "economy-overview-box"
  }, [_c('div', {
    staticClass: "period"
  }, [_vm._v("\n                                Realiseret for perioden\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            EBITDA\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "large-title"
  }, [(_vm.keyfigures) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.keyfigures.ebitda)))]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            Solgte timer\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "large-title"
  }, [(_vm.keyfigures) ? _c('span', [_vm._v(_vm._s(_vm._f("number")(_vm.keyfigures.hours)))]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            DB pr. time\n                                        ")]), _vm._v(" "), (_vm.keyfigures) ? _c('div', {
    staticClass: "large-title",
    class: {
      'color-bad': _vm.keyfigures.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'color-avg': _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value && _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) < _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value, 'color-good': _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(_vm.keyfigures.coverage_per_hour)) + "\n                                            \n                                        ")]) : _c('div', {
    staticClass: "large-title"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('expected-ebitda')], 1)])]), _vm._v(" "), _c('value-chain'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.calculations.offer,
      "icon": "file-alt",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "offerProjects",
      "tooltipIdentifier": "index.offerProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.calculations.open,
      "icon": "inbox-in",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "openProjects",
      "tooltipIdentifier": "index.openProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.calculations.ongoing,
      "icon": "clock",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "ongoingProjects",
      "tooltipIdentifier": "index.ongoingProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.calculations.snoozed,
      "icon": "snooze",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "snoozedProjects",
      "tooltipIdentifier": "index.snoozedProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.calculations.claims,
      "icon": "comment-exclamation",
      "state": "good",
      "linkParent": "ProjectsOperations",
      "linkChild": "openClaims",
      "tooltipIdentifier": "index.openClaims"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.calculations.unbilled,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "noInvoiceProjects",
      "tooltipIdentifier": "index.unbilledProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.calculations.payment_pending,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "EconomyOperations",
      "linkChild": "unpaidInvoices",
      "tooltipIdentifier": "index.unpaidInvoices"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.calculations.payment_exceeded,
      "icon": "calendar-exclamation",
      "state": "bad",
      "totalValue": _vm.calculations.payment_exceeded_total,
      "linkParent": "EconomyOperations",
      "linkChild": "exceededPayments",
      "tooltipIdentifier": "index.overdueInvoices"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd1bf60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 909
// module chunks = 0